import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_LOGGED_AS_EXHIBITOR } from "data/navigation";

function NavigationLogged() {
  return (
    <ul className="nc-Navigation flex items-center">
      {NAVIGATION_LOGGED_AS_EXHIBITOR.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export default NavigationLogged;
